import { render, staticRenderFns } from "./wxlogin.vue?vue&type=template&id=4ec0e4e1&scoped=true&"
import script from "./wxlogin.vue?vue&type=script&lang=js&"
export * from "./wxlogin.vue?vue&type=script&lang=js&"
import style0 from "./wxlogin.vue?vue&type=style&index=0&id=4ec0e4e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0e4e1",
  null
  
)

export default component.exports